/* unplugin-vue-components disabled */import { render } from "./newslist.vue?vue&type=template&id=25a8e2bc"
import script from "./newslist.vue?vue&type=script&lang=js"
export * from "./newslist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__